import { render, staticRenderFns } from "./ResponseFeedback.vue?vue&type=template&id=1519effe&scoped=true&"
import script from "./ResponseFeedback.vue?vue&type=script&lang=js&"
export * from "./ResponseFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1519effe",
  null
  
)

export default component.exports